module.exports = __webpack_public_path__ + "img/edit.4d8e8ed6.svg";